import GroupPushVue from '@/views/sic/group-push/group-push.vue';

const basePath = '/sic/group-push';
const role = 'sic'; // 角色身份

export const SIC_GROUP_PUSH_INDEX = 'sic-group-push-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: GroupPushVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_GROUP_PUSH_INDEX,
      component: () => import(
        /* webpackChunkName: "groupPush" */
        `@/views/${role}/group-push/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
